import { useAtom } from 'jotai';
import { globalDataStore, jichitaiDataAtom } from 'src/jotai/atom';

export const useJichitaiData = () => {
  const [jichitaiData] = useAtom(jichitaiDataAtom, { store: globalDataStore });

  return { jichitaiData: jichitaiData };
};
